// src/app/auth/login/ChooseProjectPanel.js
import React from 'react';
import { Button, Typography } from '@material-ui/core';

const getLabelStyle = (label) => {
  const s = String(label ?? '');
  return s.length > 10 ? { fontSize: '0.8em', lineHeight: 1.1 } : undefined; // alap marad
};

export default function ChooseProjectPanel({ projects = [], onSelect, onRefresh, disabled }) {
  return (
    <div className="w-full mt-12">
      <Typography variant="subtitle1" className="w-full text-center mb-8 opacity-80 text-xs">
        Choose a project to continue
      </Typography>

      {Array.isArray(projects) && projects.length > 0 ? (
        <div className="flex flex-wrap gap-8">
          {projects.map((p) => {
            const label = p.name ?? String(p.id);
            return (
              <Button
                className="flex-1"
                key={p.id ?? p.name}
                variant="contained"
                disabled={!!disabled}
                onClick={() => (onSelect ? onSelect(p) : console.log('[chooseProject] select:', p))}
              >
                <span style={getLabelStyle(label)}>{label}</span>
              </Button>
            );
          })}
        </div>
      ) : (
        <div className="flex items-center gap-12">
          <Typography variant="body2" className="opacity-60 text-xs">
            No projects available yet.
          </Typography>
          <Button
            variant="text"
            disabled={!!disabled}
            onClick={() => (onRefresh ? onRefresh() : console.log('[chooseProject] refresh'))}
          >
            Refresh
          </Button>
        </div>
      )}
    </div>
  );
}
